"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _cursorPosition = _interopRequireDefault(require("../../utils/cursorPosition"));

var _getIssuer = _interopRequireDefault(require("./utils/getIssuer"));

var _formatter = _interopRequireDefault(require("./utils/formatter"));

var _syntheticEvent = _interopRequireDefault(require("../../utils/syntheticEvent"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireDefault(require("../Input"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _icon = _interopRequireDefault(require("./style/icon"));

var _root = _interopRequireDefault(require("./style/root"));

var _iconWrapper = _interopRequireDefault(require("./style/iconWrapper"));

var _omit = _interopRequireDefault(require("lodash/omit"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var inputReservedStyles = {
  paddingRight: '30px',
  width: '100%'
};

var CardInput = _react["default"].forwardRef(function (_ref, ref) {
  var _input$current;

  var elementRef = _ref.elementRef,
      value = _ref.value,
      Component = _ref.component,
      onChange = _ref.onChange,
      onPaste = _ref.onPaste,
      theme = _ref.theme,
      className = _ref.className,
      style = _ref.style,
      maxLength = _ref.maxLength,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["elementRef", "value", "component", "onChange", "onPaste", "theme", "className", "style", "maxLength"]);

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      cursor = _useState2[0],
      setCursor = _useState2[1];

  var _useState3 = (0, _react.useState)((0, _getIssuer["default"])(value)),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      issuer = _useState4[0],
      setIssuer = _useState4[1];

  var input = (0, _react.useRef)(null);

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      changed = _useState6[0],
      setChanged = _useState6[1];

  var handleChange = (0, _react.useCallback)(function (event) {
    if (typeof onChange === 'function') {
      var _cursor = (0, _slicedToArray2["default"])(cursor, 1),
          update = _cursor[0];

      if (update) {
        update(event);
      }

      onChange(event);
      setChanged(true);
    }
  }, [onChange, cursor]);
  var handlePaste = (0, _react.useCallback)(function (event) {
    // pasted value is limited by maxLength
    // ex: if maxLength is 8 and pasted value is 88889999
    // value in model will be 88889999
    // formatted value will be 8888 999
    // we must prepare pasted value due to format
    var value = event.clipboardData.getData('Text');
    var target = {
      name: input.current.name,
      type: input.current.type,
      focus: input.current.focus,
      value: (0, _formatter["default"])(value, maxLength)
    };

    if (typeof onChange === 'function') {
      onChange((0, _syntheticEvent["default"])(target));
    }

    if (typeof onPaste === 'function') {
      onPaste(event);
    }
  }, [onPaste]);
  (0, _react.useEffect)(function () {
    return setIssuer((0, _getIssuer["default"])(value));
  }, [value]);
  (0, _react.useEffect)(function () {
    if (input.current) {
      setCursor((0, _cursorPosition["default"])(input, /[\d,.-]/));
    }
  }, [input === null || input === void 0 ? void 0 : input.current]); // add refs

  (0, _react.useEffect)(function () {
    if (ref) {
      ref.current = input.current;
    }

    if (typeof elementRef === 'function') {
      elementRef(input.current);
    } else if ((0, _typeof2["default"])(elementRef) === 'object') {
      elementRef.current = input.current;
    }

    return function () {
      if (ref) {
        ref.current = null;
      }

      if (typeof elementRef === 'function') {
        elementRef(null);
      } else if ((0, _typeof2["default"])(elementRef) === 'object') {
        elementRef.current = null;
      }
    };
  }, [ref, elementRef]);
  var formatterValue = (0, _react.useMemo)(function () {
    return (0, _formatter["default"])(value, maxLength);
  }, [value]);

  var _useMemo = (0, _react.useMemo)(function () {
    var computedTheme = (0, _mergeTheme["default"])(theme, style);
    return [computedTheme, _objectSpread({}, (0, _omit["default"])(computedTheme, ['appearanceMC', 'appearanceVisa', 'appearanceCard']), {}, inputReservedStyles)];
  }, [theme, style]),
      _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 2),
      styles = _useMemo2[0],
      inputStyle = _useMemo2[1];

  var Icon = (0, _react.useMemo)(function () {
    var visa = issuer.visa,
        mc = issuer.mc;

    if (!visa && !mc) {
      return styles.appearanceCard;
    } else if (mc) {
      return styles.appearanceMC;
    } else if (visa) {
      return styles.appearanceVisa;
    }
  }, [issuer]);

  if (typeof Icon === 'string') {
    Icon = _react["default"].createElement(_icon["default"], {
      img: Icon
    });
  }

  (0, _react.useEffect)(function () {
    if (changed) {
      var _cursor2 = (0, _slicedToArray2["default"])(cursor, 2),
          update = _cursor2[0],
          set = _cursor2[1];

      if (set) {
        set(formatterValue);
      }

      setChanged(false);
    }
  }, [value]);
  return _react["default"].createElement(_root["default"], {
    theme: styles,
    className: className
  }, _react["default"].createElement(Component, (0, _extends2["default"])({
    maxLength: maxLength,
    value: formatterValue,
    onChange: handleChange,
    onPaste: handlePaste,
    ref: input,
    style: inputStyle
  }, rest)), _react["default"].createElement(_iconWrapper["default"], {
    noIssuer: !issuer.visa && !issuer.mc,
    height: (_input$current = input.current) === null || _input$current === void 0 ? void 0 : _input$current.offsetHeight
  }, _react["default"].createElement(Icon, null)));
});

CardInput.defaultProps = {
  placeholder: '0000 0000 0000 0000',
  maxLength: 19,
  autoComplete: 'cc-number',
  floating: false,
  type: 'tel',
  component: _Input["default"]
};
CardInput.propTypes = {
  autoComplete: _propTypes["default"].string,
  floating: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  type: _propTypes["default"].string,
  onPaste: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].any,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  maxLength: _propTypes["default"].number,
  elementRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  component: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default Mastercard
     */
    appearanceMC: _propTypes["default"].func,

    /**
     * @default Visa
     */
    appearanceVisa: _propTypes["default"].func,

    /**
     * @default Card
     */
    appearanceCard: _propTypes["default"].func
  })
};
var _default = CardInput;
exports["default"] = _default;